import React from 'react';
import {useTranslation} from "react-i18next";
import {formatNumberFloat} from "../../../../utils/helpers";
import StatusBadge from "../../../../components/StatusBadge";
import {PAYD_URL} from "../../../../utils/env";
import ButtonInternalLink from "../../../../components/ButtonInternalLink";

function SimplePaymentList({records, setLinkToShow}) {
    const {t} = useTranslation();

    if (!records?.data?.length) return (
        <div className="bg-white rounded-[2rem] p-10 text-center shadow-sm border border-gray-100">
            <p className="text-gray-400 font-medium">No payments found</p>
        </div>
    );

    return (
        <div className="bg-white rounded-[2rem] shadow-sm border border-gray-100 overflow-hidden">
            <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="border-b border-gray-50 bg-gray-50/50">
                            <th className="px-6 py-4 text-xs font-bold uppercase tracking-widest text-gray-400">ID / Ref</th>
                            <th className="px-6 py-4 text-xs font-bold uppercase tracking-widest text-gray-400">Amount</th>
                            <th className="px-6 py-4 text-xs font-bold uppercase tracking-widest text-gray-400">Customer</th>
                            <th className="px-6 py-4 text-xs font-bold uppercase tracking-widest text-gray-400">Status</th>
                            <th className="px-6 py-4 text-xs font-bold uppercase tracking-widest text-gray-400">Env</th>
                            {/*<th className="px-6 py-4 text-xs font-bold uppercase tracking-widest text-gray-400">Created</th>*/}
                            <th className="px-6 py-4 text-xs font-bold uppercase tracking-widest text-gray-400">Paid</th>
                            <th className="px-6 py-4 text-xs font-bold uppercase tracking-widest text-gray-400 text-right">Actions</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-50">
                        {records?.data?.map((record) => (
                            <tr key={record?.paymentUuid} className="hover:bg-gray-50/50 transition-colors group">
                                <td className="px-6 py-4 align-middle whitespace-nowrap">
                                    <span className="text-sm font-mono text-gray-900 font-bold">{record?.paymentUuid}</span>
                                </td>
                                <td className="px-6 py-4 align-middle whitespace-nowrap">
                                    <span className="text-sm text-[#0b6a8c] font-black">
                                        {formatNumberFloat(record?.amount, ['DA', 'DZD'].includes(record?.currency?.symbol) ? 'fr-DZ' : 'en-US')} {record?.currency?.symbol || ''}
                                    </span>
                                </td>
                                <td className="px-6 py-4 align-middle max-w-[220px]">
                                    <div className="flex items-center gap-2 min-w-0">
                                        <span className="truncate text-sm font-bold text-gray-900">{record?.name || '-'}</span>
                                        {record?.email && <span className="truncate text-xs text-gray-500 hidden lg:inline">({record?.email})</span>}
                                    </div>
                                </td>
                                <td className="px-6 py-4 align-middle whitespace-nowrap">
                                    <StatusBadge status={record?.status}/>
                                </td>
                                <td className="px-6 py-4 align-middle whitespace-nowrap">
                                    {record?.test ?
                                        <span className="text-[10px] font-bold text-rose-600 bg-rose-50 px-2 py-0.5 rounded-full border border-rose-100 uppercase">Test</span> :
                                        <span className="text-[10px] font-bold text-green-600 bg-green-50 px-2 py-0.5 rounded-full border border-green-100 uppercase">Live</span>
                                    }
                                </td>
                                {/*<td className="px-6 py-4 align-middle whitespace-nowrap text-xs text-gray-500">*/}
                                {/*    {record?.createdAt || '-'}*/}
                                {/*</td>*/}
                                <td className="px-6 py-4 align-middle whitespace-nowrap text-xs text-gray-500">
                                    {record?.paidAt || '-'}
                                </td>
                                <td className="px-6 py-4 align-middle">
                                    <div className="flex items-center justify-end gap-2">
                                        <button
                                            className="text-xs font-bold uppercase tracking-wider bg-white text-gray-600 border border-gray-200 px-4 py-2 rounded-full hover:bg-gray-50 hover:border-cyan-300 hover:text-[#0b6a8c] transition-all shadow-sm"
                                            onClick={() => {
                                                setLinkToShow(`${PAYD_URL}/pay/${record?.paymentUuid}`)
                                            }}>
                                            Share
                                        </button>
                                        <ButtonInternalLink
                                            className="justify-center !px-4 !py-2 !text-xs tracking-wider uppercase"
                                            href={`/merchant/payments/view/${record?.paymentUuid}`}>
                                            View
                                        </ButtonInternalLink>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default SimplePaymentList;
